import { z } from "zod";

// What happened to an email after it left: the email service reports each
// step (delivered, opened, bounced, marked as spam, delayed) and Clevis keeps
// the furthest one on the send it belongs to.

export const EMAIL_DELIVERY_STATUSES = ["sent", "delayed", "delivered", "opened", "bounced", "complained"] as const;
export const EmailDeliverySchema = z.object({
  status: z.enum(EMAIL_DELIVERY_STATUSES),
  at: z.number(),
  /** The bounce reason, when there is one. */
  detail: z.string().max(300).default(""),
});
export type EmailDelivery = z.infer<typeof EmailDeliverySchema>;

/** Later steps win; a bounce or spam report always shows. */
export const DELIVERY_RANK: Record<EmailDelivery["status"], number> = { sent: 0, delayed: 1, delivered: 2, opened: 3, bounced: 4, complained: 5 };

export const DELIVERY_LABEL: Record<EmailDelivery["status"], string> = {
  sent: "sent",
  delayed: "delayed",
  delivered: "delivered",
  opened: "opened",
  bounced: "bounced",
  complained: "marked as spam",
};
